var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: "", size: "small", "label-width": "120px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "SKU编码：" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticStyle: { width: "300px" },
                          attrs: {
                            placeholder: "请输入",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.skuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "skuCode", $$v)
                            },
                            expression: "listPram.skuCode",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "SPU编码：" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticStyle: { width: "300px" },
                          attrs: {
                            placeholder: "请输入",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.spuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "spuCode", $$v)
                            },
                            expression: "listPram.spuCode",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称：" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticStyle: { width: "300px" },
                          attrs: {
                            placeholder: "请输入",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.productName,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "productName", $$v)
                            },
                            expression: "listPram.productName",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品分类：" } },
                    [
                      _c("el-cascader", {
                        staticClass: "selWidth ",
                        staticStyle: { width: "300px" },
                        attrs: {
                          options: _vm.merCateList,
                          props: {
                            value: "id",
                            label: "name",
                            children: "child",
                            expandTrigger: "hover",
                            checkStrictly: true,
                          },
                          clearable: "",
                          "show-all-levels": false,
                          size: "small",
                        },
                        on: { change: _vm.handerSearch },
                        model: {
                          value: _vm.listPram.categoryIds,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "categoryIds", $$v)
                          },
                          expression: "listPram.categoryIds",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "mr10",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.handlerOpenConfig },
                    },
                    [_vm._v("新增卡券类型")]
                  ),
                  _vm._v(" "),
                  _c("async-export-button", {
                    staticClass: "mr10",
                    attrs: {
                      type: "platform_carmine",
                      params: _vm.carmineExportParams,
                      "button-text": "结果卡密导出",
                      "button-type": "primary",
                      size: "small",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "spuCode", label: "SPU编码" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "skuCode", label: "SKU编码" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "productName", label: "商品名称" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "productAttr", label: "规格" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "stock", label: "库存量" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "updateTime", label: "最后更新时间" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "remark", label: "备注" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "100",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.goKamiDetail(
                                  scope.row.id,
                                  scope.row.productName
                                )
                              },
                            },
                          },
                          [_vm._v("库存详情")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.downloadFile("downloadKami", {
                                  skuId: scope.row.id,
                                })
                              },
                            },
                          },
                          [_vm._v("卡密下载")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("EditConfig", {
        ref: "EditConfigRef",
        on: { doRefresh: _vm.handlerGetListData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }